/**
 * External dependencies
 */
import Swiper from 'swiper/bundle';

/**
 * Init slider.
 *
 * @param {String} container
 * @param {Object} options
 * @returns {Void}
 */
function initSlider(container, options) {
	const prevEl = container.querySelector('.swiper-button-prev');
	const nextEl = container.querySelector('.swiper-button-next');
	const pagination = container.parentNode.querySelector('.swiper-pagination');

	new Swiper(container, {
		spaceBetween: 16,
		slidesPerView: 1,
		breakpoints: {},
		...(prevEl && nextEl
			? {
					navigation: { prevEl, nextEl },
				}
			: {}),
		...(pagination
			? {
					pagination: {
						el: pagination,
						clickable: true,
					},
				}
			: {}),
		...options,
	});
}

/**
 * Init sliders.
 */
document.querySelectorAll('.js-slider-tiles .swiper').forEach((container) => {
	initSlider(container, {
		slidesPerView: 1,
		spaceBetween: 22,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 4,
			},
		},
	});
});

document.querySelectorAll('.js-slider-image-content .swiper').forEach((container) => {
	initSlider(container, {
		slidesPerView: 1,
		spaceBetween: 50,
	});
});
